(function(){
    document.addEventListener('DOMContentLoaded', function() {
        var window_width             = window.innerWidth / 2;
        var window_height            = window.innerHeight / 2;
        var animated_elements        = document.querySelectorAll('.seismic_animated_elements');
        var valid_property_prefix    = '';
        var other_property           = 'perspective(1000px)';
        var animated_elements_styles = animated_elements[0].style;

        if(typeof animated_elements_styles.webkitTransform == 'string') {
            valid_property_prefix = 'webkitTransform';
        } else if (typeof animated_elements_styles.MozTransform == 'string') {
            valid_property_prefix = 'MozTransform';
        }

        function animate_elements(event) {
            var element_center_x = event.clientX - window_width;
            var element_center_y = window_height - (event.clientY + 13);
            var element_deg_x    = element_center_x * 0.02;
            var element_deg_y    = element_center_y * -0.02;
            var element_px_x     = element_center_x * 0.02;
            var element_px_y     = element_center_y * -0.02;

            var elements_count = animated_elements.length;
            for (var i = 0; i < elements_count; i++) {
                // element_px_x = i % 3 ? element_px_x * -1 : element_px_x;
                // element_px_y = i % 3 ? element_px_y * -1 : element_px_y;
                // animated_elements[i].style[valid_property_prefix] = other_property + 'translate3d(' + element_px_x + 'px, ' + element_px_y + 'px, 0px) rotateY('+ element_deg_x +'deg)  rotateX('+ element_deg_y +'deg)';
                animated_elements[i].style[valid_property_prefix] = other_property + 'translate3d(' + element_px_x + 'px, ' + element_px_y + 'px, 0px)';

                /**
                 * An annoying safari bug is preventing the use of rotate here.
                 * The issues lies in the footer and the sitcky position we have on it.
                 * https://stackoverflow.com/questions/18146511/bug-in-css3-rotatey-transition-on-safari
                 * https://stackoverflow.com/questions/16348489/is-there-a-css-hack-for-safari-only-not-chrome
                 */
            };
        }

        document.addEventListener('mousemove', animate_elements);
    })
})();
